<template>
	<div class="modal fade" id="modal-denuncia">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				
				<div class="modal-header">
					<h4 class="modal-title">{{view_nome.denuncia_detalhe}}</h4>
					<button type="button" class="close" data-dismiss="modal">
						<img :src="logotipo" style="width: 30px; height: 35px; opacity: 1;">
						&times;
					</button>
				</div>

				<div class="modal-body" v-if="!denuncia.conclusao_id">
					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label>Unidades envolvidas</label>
								<select multiple readonly class="form-control form-control-sm" id="env_unidades" @dblclick="rmv_envolvido">
									<option v-for="opt in envolvidos.unidades" :value="opt" :key="opt">{{ opt }}</option>
								</select>
							</div>
							<div v-if="!block" class="input-group mb-3 input-group-sm">
								<input type="text" class="form-control" id="new_env_unidade" @keyup.enter="add_envolvido('unidade')">
								<div class="input-group-append">
									<button class="btn btn-primary" @click="add_envolvido('unidade')">add</button> 
								</div>
							</div>
						</div>

						<div class="col-md-4">
							<div class="form-group">
								<label>{{view_nome.agente_envolvidos}}</label>
								<select multiple readonly class="form-control form-control-sm" id="env_pessoas" @dblclick="rmv_envolvido">
									<option v-for="opt in envolvidos.pessoas" :value="opt" :key="opt">{{ opt }}</option>
								</select>
							</div>
							<div v-if="!block" class="input-group mb-3 input-group-sm">
								<input type="text" class="form-control" id="new_env_pessoa" @keyup.enter="add_envolvido('pessoa')">
								<div class="input-group-append">
									<button class="btn btn-primary" @click="add_envolvido('pessoa')">add</button> 
								</div>
							</div>
						</div>

						<div class="col-md-4">
							<div class="form-group">
								<label>Cargos</label>
								<select multiple readonly class="form-control form-control-sm" id="env_cargos" @dblclick="rmv_envolvido">
									<option v-for="opt in envolvidos.cargos" :value="opt" :key="opt">{{ opt }}</option>
								</select>
							</div>
							<div v-if="!block" class="input-group mb-3 input-group-sm">
								<input type="text" class="form-control" id="new_env_cargo" @keyup.enter="add_envolvido('cargo')">
								<div class="input-group-append">
									<button class="btn btn-primary" @click="add_envolvido('cargo')">add</button> 
								</div>
							</div>
						</div>
					</div>

					<div class="d-sm-flex justify-content-between mb-3">
						<div class="p-2 mr-1">
							<b>ID: </b> {{ denuncia.id }}
						</div>

						<div v-if="block" class="p-2 mr-1">
							<b>Usuário: </b> {{ ator.name }}
						</div>

						<div v-if="!block" class="p-2 mr-1">
							<b>Protocolo: </b> {{ denuncia.protocolo }}
						</div>

						<div v-if="!block" class="p-2 mr-1">
							<b>Origem: </b> {{ Phone(denuncia.origem) }}
						</div>

						<div class="p-2 mr-1">
							<b>Data: </b> {{ denuncia.created_at | moment("DD/MM/YYYY") }}
						</div>

						<div class="p-2 mr-1">
							<b>Hora: </b> {{ convert_hor(denuncia.created_at) | moment("HH:mm:ss") }}
						</div>
					</div>

					<div v-if="denuncia.anexo_count">
						<div class="d-sm-flex justfy-content-between">
							<div class="p-2" v-for="anexo in denuncia.anexo" :key="anexo.id">
								<input type="hidden" v-if="carrega_anexo(anexo)"> 
								<button class="btn btn-sm btn-light" @click="view_anexo(anexo)" >{{anexo.nome}}</button>
							</div>
						</div>

						<hr>
					</div>

					<div class="d-sm-flex justify-content-center mb-3" v-if="denuncia.complemento_count">
						<p class="text-center pointer clique-aqui" data-dismiss="modal" @click="go_datails">
							Esta {{view_nome.denuncia_detalhe}} contém {{ denuncia.complemento_count }} complementos. Clique aqui para ver.
						</p>
					</div>
                    <Loading  v-if="loading_audio" />
					<player ref="wavesurfer" :class="(!audio.hash) ? 'hidden' : ''" :audio_hash="audio.hash" />

					<div class="row">
						<div class="col-md-3">
							<div class="form-group">
								<label>Local do ocorrido</label>
								<input type="text" class="form-control form-control-sm" v-model="denuncia.local">
							</div>
						</div>

						<div class="col-md-3">
							<div class="form-group">
								<label>{{view_nome.tipo_denuncia}}</label>
								<select name="type" id="type"  class="form-control form-control-sm"  :class="[(denuncia.type) ? '' : incomplete]" v-model="denuncia.type">
									<option v-for="type in denuncia_type" :value="type.id" :key="type.id">{{ type.nome }}</option>
								</select>
							</div>
						</div>

						<div class="col-md-3">
							<div class="form-group">
								<label>Data</label>
								<input type="date" class="form-control form-control-sm" v-model="denuncia.data">
							</div>
						</div>

						<div class="col-md-3">
							<div class="form-group">
								<label>Hora</label>
								<input type="time" class="form-control form-control-sm" v-model="denuncia.hora">
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-8">
							<div class="form-group">
								<label  for="resumo">Resumo</label>
								<small class="info link" data-toggle="popover" data-content="Descrição sucinta sobre o conteúdo do áudio.">
									<i class="fas fa-question-circle"></i>
								</small>
								<input v-if="denuncia.nota_interna" type="text" id="resumo" class="form-control form-control-sm" v-model="denuncia.nota_interna.resumo" :readonly="block">
							</div>
						</div>

						<div class="col-md-4" v-if="view_nome.tipo_delito_lig == 1">
							<div class="form-group">
								<label  for="delito">{{view_nome.tipo_delito}}</label>
								<small class="info link" data-toggle="popover" data-content="Aponta, se houver, o tipo de {{view_nome.tipo_delito}} ocorrido nesta {{view_nome.denuncia_detalhe}}.">
									<i class="fas fa-question-circle"></i>
								</small>
								<input v-if="denuncia.nota_interna" type="text" id="delito" class="form-control form-control-sm" v-model="denuncia.nota_interna.delito" :readonly="block">
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-4">
							<div class="form-group">
								<label  for="prioridade">Prioridade</label>
								<select v-if="denuncia.nota_interna" name="prioridade" id="prioridade" class="form-control form-control-sm" v-model="denuncia.nota_interna.prioridade" :readonly="block">
									<option v-for="den_prioridade in denuncia_prioridade" :value="den_prioridade.id" :key="den_prioridade.id">{{ den_prioridade.nome }}</option>
								</select>
							</div>
						</div>

						<div class="col-md-4">
							<div class="form-group">
								<label  for="status">Status</label>
								<select v-if="denuncia.nota_interna" id="statusDn" class="form-control form-control-sm" v-model="denuncia.nota_interna.status_id" :readonly="block">
									<option v-for="den_status in denuncia_status" :value="den_status.id" :key="den_status.id">{{ den_status.nome }}</option>
								</select>
							</div>
						</div>
					</div>
					
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label v-if="denuncia.denuncia" for="transcricao">{{view_nome.denuncia}}</label>
								<label v-else for="transcricao">Transcrição <!--<font-awesome-icon icon="file-signature" class="pointer info ml-1" title="Transcrever automaticamente" @click="transcript" />--></label>

								<textarea v-if="denuncia.denuncia" class="form-control form-control-sm" id="transcricao" cols="30" rows="6"  v-model="denuncia.denuncia" readonly></textarea>

								<transition v-else mode="out-in" name="leftIn">
									<Loading  v-if="loading" />
									<textarea v-else class="form-control form-control-sm" name="transcricao" id="transcricao" cols="30" rows="6"  v-model="audio.transcricao" :readonly="block"></textarea>
								</transition>
							</div>
						</div>
					
						<div class="col-md-6">
							<div class="form-group">
								<label  for="analise">Análise</label>
								<textarea v-if="denuncia.nota_interna" class="form-control form-control-sm" name="analise" id="analise" cols="30" rows="6"  v-model="denuncia.nota_interna.analise" :readonly="block"></textarea>
							</div>
						</div>
					</div>

				</div>

				<conclusao v-else :denuncia="denuncia" />
				
					<alert ref="alert" />
				<div v-if="!block" class="modal-footer">
					<div class="row">
						<div class="col-auto">
							<button class="btn btn-sm btn-primary" @click="atualizar" title="Salvar alterações feitas." v-if="!denuncia.conclusao_id">Salvar</button>
							<button class="btn btn-sm ml-1 btn-success" @click="encerrar_denuncia" title="Declarar como encerrada." v-if="!denuncia.conclusao_id">Encerrar</button>
							<button class="btn btn-sm ml-1 btn-warning" @click="view_denunciante(denuncia.denunciante_id)">{{view_nome.denunciante_nome}}</button>

							<router-link :to="{name: 'Denuncia', params: {get: 'Denuncias', denuncia_id: denuncia.id} }" class="ml-1">
								<button class="btn btn-sm btn-info" data-dismiss="modal" title="Ver histórico de alterações.">Histórico</button>
							</router-link>

							<button class="btn btn-sm ml-1 btn-danger" data-dismiss="modal" v-if="!denuncia.conclusao_id">Cancelar</button>
						</div>
					</div>
				</div>

			</div>
		</div>

		<denunciante ref="denunciante" @save="new_denunciante" />
		<mAnexo :attachment="mAnexo_data" name="modal-anexo-den" />
	</div>
</template>

<script>
	import api         from "@/mixins/api.js"
    import alert       from '@/components/Tools/alert'
	import replace     from "@/mixins/replace.js"
	import player      from "@/components/Tools/Player"
	import conclusao   from './Conclusao'
	import denunciante from './Denunciante'
	import mAnexo      from '@/components/Modal/anexo'

	export default {
		name: "modal-denuncia",
		props: [ 'denuncia', 'block' ],
		mixins: [ api, replace ],
		components: { player, conclusao, denunciante, alert, mAnexo },

		data: () => { 
			return {
				incomplete: false,
				loading: false,
				loading_audio: false,
				audio: { hash: null, path: null, transcricao: null},
				ator: {},
				count: {},
				estado: {},
				unidades: {},
				mAnexo_data: {},
				envolvidos: { unidades: [], pessoas: [], cargos: [] },
			}
		},

		mounted() {
			this.verificaNota(),
			//this.load_unidades(),
			this.load_denuncia_type(),
			this.load_denuncia_status(),
			this.load_denuncia_prioridade()

			
		},

		watch: {
			denuncia() { 
				this.envolvidos = { 
					unidades: [], 
					pessoas: [], 
					cargos: [] 
				}
				this.block ? this.load_activity() : this.load_data()
			}
		},

		computed: {
			logotipo() { 
				return this.$store.state.config.logotipo;
			},

			usuario()  { 
				return this.$store.state.user;
			},

			is_adm()   { 
				return ( this.$store.state.user.type > 1 );
			},

			view_nome(){ 
				return this.$store.state.config_view_menu;
			}
		},

		methods: {
			async load_unidades() {
				const response = await this.GET("Unidade");

				if ( response.status == "success" ){
					this.unidades = response.result;
				}
			},

			async load_denuncia_type() {
				const response = await this.GET("Denuncia/DenunciaType");

				if ( response.status == "success" ){
					this.denuncia_type = response.result;
				}
			},

			async load_denuncia_prioridade() {
				const response = await this.GET("Denuncia/DenunciaPrioridade");

				if ( response.status == "success" ){
					this.denuncia_prioridade = response.result;
				}
			},

			async load_denuncia_status() {
				const response = await this.GET("Denuncia/DenunciaStatus");

				if ( response.status == "success" ){
					this.denuncia_status = response.result;
				}
			},

			async load_data() {
				this.audio.hash = null;
				this.load_audio();
				this.load_envolvidos();
			},

			async load_audio() {
                const response = await this.GET("Audio", this.denuncia.gravacao_id);
				//this.audio.hash = await this.GET("Audio/pegaAudio",{ path: response.path }) || null
				this.audio.path = response.path;

				this.audio.transcricao = response.transcricao || ""
				if((response.file == "" || response.file == null) && response.path != null){
					this.carrega_audio(response.path);
					this.transcript(this.audio);
				}else{
					this.audio.hash = response.file;
				}
			},
			
			async carrega_audio(caminho){
				
				if(!caminho){
					this.audio.hash = null;
					this.loading_audio = false;
				}else{
					this.loading_audio = true;
					const response = await this.POST("Audio/pegaAudio",{ path: caminho });				
					if(this.loading_audio){
						this.audio.hash = response;
					}
					this.loading_audio = false;
				}
			},

			async carrega_anexo(anexo_aux){
				const response = await this.POST("Denuncia/Anexo/pegaArquivo",{ path: anexo_aux.path, tipo: anexo_aux.type});
				anexo_aux.file = response;
			},

			async verificaNota(){
				if(!this.denuncia.nota_interna){
					const response = await this.GET("Denuncia/Historico",1);
					this.denuncia.nota_interna = response;
				}
			},

			async load_activity() {
				this.estado = this.denuncia;
				this.load_envolvidos();

				const response = await this.GET("User", this.estado.usuario);
				this.ator = (response.status == 'success') ? response.result : {}
			},

			async transcript(audio) {
					if(audio.transcricao == ""){
						this.loading = true;
						const response = await this.POST("CPQD/ASR/DENUNCIA", { path: audio.path, gravacao_id: this.denuncia.gravacao_id });
						audio.transcricao = response;
						this.atualizar();
						this.loading = false;
					}
			},

			async view_denunciante(payload) {
				this.$refs.denunciante.show(payload);
			},

			load_envolvidos() {
				if ( this.denuncia.nota_interna.env_unidades ){ 
					this.envolvidos.unidades = this.denuncia.nota_interna.env_unidades.split(',');
				}

				if ( this.denuncia.nota_interna.env_pessoas ){ 
					this.envolvidos.pessoas = this.denuncia.nota_interna.env_pessoas.split(',');
				}

				if ( this.denuncia.nota_interna.env_cargos ){ 
					this.envolvidos.cargos = this.denuncia.nota_interna.env_cargos.split(',');
				}
			},

			async atualizar() {
				if ( !this.denuncia.type) {
					window.alert("Preencha os campos obrigatórios!");
					this.incomplete = "focus";
				}else{
					if ( this.envolvidos.unidades ){
						this.denuncia.nota_interna.env_unidades = this.envolvidos.unidades.join(',');
					}

					if ( this.envolvidos.pessoas ){
						this.denuncia.nota_interna.env_pessoas = this.envolvidos.pessoas.join(',');
					}

					if ( this.envolvidos.cargos ){
						this.denuncia.nota_interna.env_cargos = this.envolvidos.cargos.join(',');
					}

					const object = {
						id:             this.denuncia.id,
						data:           this.denuncia.data,
						hora:           this.denuncia.hora,
						local:          this.denuncia.local,
						type:			this.denuncia.type,
						gravacao_id:    this.denuncia.gravacao_id,
						denunciante_id: this.denuncia.denunciante_id,
						audio:          this.audio,

						nota_interna: {
							resumo:       this.denuncia.nota_interna.resumo,
							delito:       this.denuncia.nota_interna.delito,
							analise:      this.denuncia.nota_interna.analise,
							status_id:    this.denuncia.nota_interna.status_id,
							//unidade_id:   this.denuncia.nota_interna.unidade_id,
							prioridade:   this.denuncia.nota_interna.prioridade,
							env_cargos:   this.denuncia.nota_interna.env_cargos,
							denuncia_id:  this.denuncia.id,
							env_pessoas:  this.denuncia.nota_interna.env_pessoas,
							transcricao:  this.audio.transcricao,
							env_unidades: this.denuncia.nota_interna.env_unidades,
						},
					}

					const response = await this.PUT("Denuncia", object);

					if ( response.status == "success"){
						this.$refs.alert.alert('Dados salvos com sucesso!', 'alert-success');
					}else{
						this.$refs.alert.alert('Problemas ao salvar dados!', 'alert-danger');
					}
				}
			},

			new_denunciante(id) {
				this.denuncia.denunciante_id = id;
				this.atualizar();
			},

			go_datails() {
				this.$router.push({ name: 'Den_details', params: {get: 'Denuncia', denuncia_id: this.denuncia.id} });
			},

			encerrar_denuncia() {
				this.$emit("close_den", this.denuncia);
			},

			add_envolvido(payload) {
				let input    = '';
				let array    = [];
				const option = document.createElement('option');

				if ( payload == 'unidade' ) {
					input  = document.getElementById("new_env_unidade");
					array  = this.envolvidos.unidades;
				}

				if ( payload == 'pessoa' ) {
					input  = document.getElementById("new_env_pessoa");
					array  = this.envolvidos.pessoas;
				}

				if ( payload == 'cargo' ) {
					input  = document.getElementById("new_env_cargo");
					array  = this.envolvidos.cargos;
				}

				if ( input.value ) {
					array.push(input.value);
					input.value = '';
				}
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			rmv_envolvido(e) {
				const option = e.target;
				const select = option.parentNode;
				let array = [];

				if ( select.id == 'env_unidades' ){
					array = this.envolvidos.unidades;
				}
				if ( select.id == 'env_pessoas' ){
					array = this.envolvidos.pessoas;
				}
				if ( select.id == 'env_cargos' ){
					array = this.envolvidos.cargos;
				}

				array.splice( array.indexOf(option.value), 1 );
			},

            view_anexo(payload) {
                this.mAnexo_data = payload;
				$("#modal-anexo-den").modal();
            },
		}
	}
</script>

<style scoped>
.clique-aqui {
	color: #DB3F40;
}

.clique-aqui:hover {
	color: #913E52;
}
</style>